import React from 'react';
import { Link } from 'react-router';
import { observer } from 'mobx-react';

// Helpers
import { getCookie, handleSwitchInputKeys } from '../../helpers/helpers';

// Translations
import translate from '../Translate.js';

// Dependencies
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown';

// Components
import * as icons from '../Icons/Icons';
import Help from '../Help/Help';
import SmarterDropdown from './SmarterDropdown';

const Header = observer(class Header extends React.Component {
  constructor(props) {
    super();
    this.handleLinkClick = this.handleLinkClick.bind(this);
    this.toggleNav = this.toggleNav.bind(this);
    this.toggleHighContrast = this.toggleHighContrast.bind(this);
    this.toggleDyslexic = this.toggleDyslexic.bind(this);
    this.hideDropdown = this.hideDropdown.bind(this);
    this.setHighContrast = this.setHighContrast.bind(this);
    this.newRefresh = this.newRefresh.bind(this);
    this.navbarKeydown = this.navbarKeydown.bind(this);
    this.setStudentDropdown = this.setStudentDropdown.bind(this);
    this.setHelpDropdown = this.setHelpDropdown.bind(this);
  }

  componentWillMount() {
    const doc = document.querySelector('html');
    const { SessionStore } = this.props.store;

    this.state = {
      navOpen: false,
      defaultSize: parseInt(window.getComputedStyle(doc).getPropertyValue('font-size'), 10),
      highContrast:  false,
      studentDropdownOpen: false,
      helpDropdownOpen: false
    }

    SessionStore.getUnreadCount();
  }

  componentDidMount() {
    const { translation } = this.props;
    const { SessionStore } = this.props.store;
    const int = 3600000; // 30 minutes
    const accessDropdown = document.getElementById('nav-access');

   if (window.localStorage.getItem('high-contrast', true)) {
     this.toggleHighContrast();
     this.setState({ highContrast: true})
   }

    // Check for new messages on an interval
    setInterval(function(){
      SessionStore.getUnreadCount(true, true, translation.new_message, '/messages');
    }, int);

    // Escape key functionality for event listener on accessibility dropdown
    accessDropdown.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        document.getElementById('accessibility-dropdown').click();
        document.getElementById('accessibility-dropdown').focus();
      }
    })
  }

  handleLinkClick() {
    const dropdowns = [];
    dropdowns.push(this.refs.reportsDropdown);
    dropdowns.push(this.refs.pagesDropdown);
    dropdowns.push(this.refs.usersDropdown);
    dropdowns.push(this.refs.accountDropdown);
    for(var i = 0; i < dropdowns.length; i++) {
      if(typeof dropdowns[i] !== 'undefined') {
        dropdowns[i].hide();
      }
    }
    this.setState({
      navOpen: false
    });
  }

  toggleNav(e) {
    e.preventDefault();
    this.setState({
      navOpen: !this.state.navOpen
    });
  }

  skipToNav(e) {
    e.preventDefault();

    const nav = document.querySelector('#nav');

    if(nav) {
      nav.focus();
    }
  }

  skipToContent(e) {
    e.preventDefault();

    const content = document.querySelector('#main-content');

    if(content) {
      content.focus();
    }
  }

  toggleHighContrast() {
    this.props.store.SessionStore.highContrast = !this.props.store.SessionStore.highContrast;

    let defaultStyles = document.querySelector('link[href*="screen.css"]');
    let highContrastStyles = document.querySelector('link[href*="hi-c.css"]');

    if(document.querySelector('html').className.indexOf('firefox') > -1) {
      if(this.props.store.SessionStore.highContrast) {
        defaultStyles.disabled = true;
        highContrastStyles.disabled = false;
      } else {
        defaultStyles.disabled = false;
        highContrastStyles.disabled = true;
      }
    } else {
      if(this.props.store.SessionStore.highContrast) {
        defaultStyles.setAttribute('rel', 'alternate stylesheet');
        highContrastStyles.setAttribute('rel', 'stylesheet');
      } else {
        defaultStyles.setAttribute('rel', 'stylesheet');
        highContrastStyles.setAttribute('rel', 'alternate stylesheet');
      }
    }
  }

  setHighContrast() {
    if (this.state.highContrast) {
      this.setState({ highContrast: false })
      localStorage.removeItem('high-contrast');
    } else if (!this.state.highContrast) {
      this.setState({ highContrast:  !this.state.highContrast})
      localStorage.setItem('high-contrast', !this.state.highContrast)
    }
    this.toggleHighContrast();
  }

  newRefresh() {
   /*  Old refresh from props was removing high contrast mode
    so I created this work around*/
    const { refresh } = this.props;
    refresh();
    if (this.state.highContrast) {
      this.toggleHighContrast();
    }
  }

  toggleDyslexic() {
    const { SessionStore } = this.props.store;

    SessionStore.dyslexic = this.dyslexic.checked;

    let dyslexicStyles = document.querySelector('link[href*="open-dyslexic.css"]');

    if(document.querySelector('html').className.indexOf('firefox') > -1) {
      if(SessionStore.dyslexic) {
        dyslexicStyles.disabled = false;
      } else {
        dyslexicStyles.disabled = true;
      }
    } else {
      if(SessionStore.dyslexic) {
        dyslexicStyles.setAttribute('rel', 'stylesheet');
      } else {
        dyslexicStyles.setAttribute('rel', 'alternate stylesheet');
      }
    }
  }

  adjustSize(type) {
    const doc = document.querySelector('html');
    let size = parseInt(window.getComputedStyle(doc).getPropertyValue('font-size'), 10);

    if(type === 'increase') {
      size += 2;
    } else if(type === 'decrease') {
      size -= 2;
    } else {
      size = this.state.defaultSize;
    }

    doc.setAttribute('style', `font-size: ${size}px`);
  }

  showDropdown() {
    const dropdowns = document.querySelectorAll('div.dropdown--active .dropdown__menu');
    const triggers = document.querySelectorAll('div.dropdown--active .dropdown__trigger');

    for(let i = 0; i < dropdowns.length; i++) {
      dropdowns[i].setAttribute('aria-hidden', 'false');
    }

    for(let i = 0; i < triggers.length; i++) {
      triggers[i].setAttribute('aria-expanded', 'true');
    }
  }

  hideDropdown() {
    const dropdowns = document.querySelectorAll('div.dropdown:not(.dropdown--active) .dropdown__menu');
    const triggers = document.querySelectorAll('div.dropdown:not(.dropdown--active) .dropdown__trigger');

    for(let i = 0; i < dropdowns.length; i++) {
      dropdowns[i].setAttribute('aria-hidden', 'true');
    }

    for(let i = 0; i < triggers.length; i++) {
      triggers[i].setAttribute('aria-expanded', 'false');
    }
  }

  setStudentDropdown(boolean) {
    this.setState({
      studentDropdownOpen: boolean
    })
  }

  setHelpDropdown(boolean) {
    this.setState({
      helpDropdownOpen: boolean
    })
  }

  navbarKeydown(e) {
    e.preventDefault();

    const closeButton = document.querySelector('a.nav-btn');
    const examBtn = document.querySelector('a.navbar__item');
    const messagesBtn = document.getElementById('messages');
    const studentBtn = document.getElementById('nav-account-trigger');
    const helpBtn = document.getElementById('help');
    const navBar = [closeButton, examBtn, messagesBtn, studentBtn, helpBtn];

    let index = Array.prototype.indexOf.call(navBar, e.target);

    const SPACE = ' ';

    switch (e.key) {
      case 'Enter':
        e.preventDefault();
        e.target.click();
        break;

      case SPACE:
        e.preventDefault();

        if (e.target === studentBtn) {
          this.state.studentDropdownOpen ? this.setStudentDropdown(false) : this.setStudentDropdown(true)
          studentBtn.click();
          break;
        }
        if (e.target === helpBtn) {
          const articles = document.getElementById('help__list').querySelectorAll('a');

          e.preventDefault();
          this.state.helpDropdownOpen ? this.setHelpDropdown(false) : this.setHelpDropdown(true);
          e.target.click();
          articles[0].focus();
          break;
        }
        e.target.click();
        break;

      case 'Tab':
        e.preventDefault();
        // Regular Tab
        if (!e.shiftKey) {
          if (this.state.helpDropdownOpen && e.target === helpBtn) {
            e.preventDefault();
            helpBtn.click();
            this.setHelpDropdown(false);
            helpBtn.focus();
            break;
          }

          if (e.target === navBar[navBar.length - 1]) {
            navBar[0].focus();
            break;
          } else {
            navBar[index + 1].focus();
            break;
          }
          //Shift Tabbing
        } else if (e.shiftKey) {
          if(e.target === navBar[0]) {
            navBar[navBar.length - 1].focus();
            break;
          } else {
            navBar[index - 1].focus();
            break;
          }
        }
        break;
      case 'ArrowDown':
        const articles = document.getElementById('help__list').querySelectorAll('a');

        if (e.target === helpBtn) {
          articles[0].focus();
        }
        break;
      case 'Escape':
        e.preventDefault();
        if (!this.state.studentDropdownOpen && !this.state.helpDropdownOpen) {
          // Clicks button to close and then sets focus to closed menu btn
          closeButton.click();
          closeButton.focus();
        }
        break;
      default:
        break;
    }
  }


  render() {
    const { translation } = this.props;
    const { SessionStore } = this.props.store;
    const { profile, userData, courseData } = SessionStore;

    let isIns = false;
    let isAdd = false;
    let isStudent = false;

    if(SessionStore.hasSessionStorage) {
      isIns = JSON.parse(sessionStorage.getItem('userData')).role.toLowerCase() === 'instructor';
      isAdd = JSON.parse(sessionStorage.getItem('userData')).role.toLowerCase() === 'administrator';
      isStudent = JSON.parse(sessionStorage.getItem('userData')).role.toLowerCase() === 'learner';
    } else {
      isIns = JSON.parse(getCookie('userData')).role.toLowerCase() === 'instructor';
      isAdd = JSON.parse(getCookie('userData')).role.toLowerCase() === 'administrator';
      isStudent = JSON.parse(getCookie('userData')).role.toLowerCase() === 'learner';
    }

    let openClass = null;
    let menuText = 'Menu';

    if(this.state.navOpen) {
      openClass = 'open';
      menuText = 'Close';
      document.querySelector('body').className += ' nav-open';
    } else {
      menuText = 'Menu';
      document.querySelector('body').classList.remove('nav-open');
    }

    return (
      <header className="site-head wrap">
        <a className="meta" href="#" onClick={(e) => {this.skipToNav(e)}}>{translation.skip_to_nav}</a>
        <a className="meta" href="#" onClick={(e) => {this.skipToContent(e)}}>{translation.skip_to_main}</a>

        <h1 className="meta">SmarterProctoring</h1>

        <a href="#nav" className={`nav-btn ${openClass}`} onClick={this.toggleNav} onKeyDown={this.navbarKeydown}>{menuText}</a>

        <nav id="nav-app-tools" role="navigation" aria-label="App tools">
          <ul className="app-tools">
            <li>
              <button
                className="access-toggle btn--outline"
                onClick={this.newRefresh}
              >
              <icons.iconRefresh />
              <span className="meta">{translation.refresh}</span>
            </button>
          </li>
          <li>
            <Dropdown
              ref="accessibilityDropdown"
              onShow={this.showDropdown}
              onHide={this.hideDropdown}
            >
              <DropdownTrigger
                className="access-toggle btn btn--outline"
                tabIndex="0"
                aria-controls="#nav-access"
                aria-haspopup="true"
                aria-expanded="false"
                title={translation.accessibility.heading}
                id="accessibility-dropdown"
              >
                <icons.iconAccess />

                <span className="meta">
                  {translation.accessibility.heading}
                </span>
              </DropdownTrigger>

              <DropdownContent>
                <ul id="nav-access" className="dropdown__menu" role="menu" aria-hidden="true">
                  <li>
                    <button
                      className={`dropdown__item ${SessionStore.highContrast ? 'enabled' : ''}`}
                      onKeyDown={this.handleAccessKeyDown}
                      id="high-constrast"
                      onClick={this.setHighContrast}
                    >
                      <icons.iconContrast />
                      {translation.accessibility.high_contrast}
                    </button>
                  </li>
                  <li>
                    <button
                      className="dropdown__item font-increase"
                      onClick={() => this.adjustSize('increase')}
                      id="increase-size"
                    >
                      <icons.iconFont />
                      {translation.accessibility.increase_size}
                    </button>
                  </li>
                  <li>
                    <button
                      className="dropdown__item font-decrease"
                      onClick={() => this.adjustSize('decrease')}
                      id="decrease-size"
                    >
                      <icons.iconFont />
                      {translation.accessibility.decrease_size}
                    </button>
                  </li>
                  <li>
                    <button
                      className="dropdown__item"
                      onClick={() => this.adjustSize('reset')}
                      id="reset-size"
                    >
                      <icons.iconFont />
                      {translation.accessibility.reset_size}
                    </button>
                  </li>
                  <li className="dropdown__item">
                    <input
                      type="checkbox"
                      id="dyslexic-font"
                      className="switch-input"
                      defaultChecked={SessionStore.dyslexic}
                      onChange={this.toggleDyslexic}
                      ref={(input) => this.dyslexic = input}
                      onKeyDown={handleSwitchInputKeys}
                    />

                    <label
                      className="switch-label"
                      htmlFor="dyslexic-font"
                    >
                      <span className="meta">
                        {translation.accessibility.dyslexic_font}
                      </span>
                      </label>

                    <label htmlFor="dyslexic-font">
                      {translation.accessibility.dyslexic_font}
                    </label>
                    </li>
                  </ul>
                </DropdownContent>
              </Dropdown>
            </li>
          </ul>
        </nav>
       {/* {This is the nav bar!!!} */}
        {this.props.router.location.pathname !== '/enroll' &&
          <nav id="nav" className={`navbar ${openClass}`} role="navigation" aria-labelledby="nav-heading" onKeyDown={this.navbarKeydown}>
            <h2 id="nav-heading" className="meta">{translation.navigation.heading}</h2>
            <ul className="navbar__menu">
              <li>
                <Link className="navbar__item" tabIndex="0" to="/" onClick={this.handleLinkClick}>

                  {isStudent &&
                    <icons.icon_text />
                  }

                  {isStudent &&
                    translation.navigation.dashboard_student
                  }

                  {!isStudent &&
                    <icons.iconDashboard />
                  }

                  {!isStudent &&
                    translation.navigation.dashboard
                  }
                </Link>
              </li>
              <SessionStore.validater>
                <li
                  iamAction="sp:DescribeReports"
                  iamResource={`ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:report`}
                >
                  <SmarterDropdown 
                    ref="reportsDropdown" 
                    id="nav-reports" 
                    triggerText={<span><icons.iconGraph />{translation.navigation.reports.anchor}</span>}
                  >
                    <li role="menuitem">
                      <Link className="dropdown__item" tabIndex="0" to="/reports" onClick={this.handleLinkClick}>
                        {translation.navigation.reports.all_reports}
                      </Link>
                    </li>
                    {!isIns &&
                      <li role="menuitem">
                        <Link className="dropdown__item" tabIndex="0" to="/reports/downloads" onClick={this.handleLinkClick}>
                          {translation.navigation.reports.downloads}
                        </Link>
                      </li>
                    }
                  </SmarterDropdown>
                </li>
              </SessionStore.validater>
              {!SessionStore.hideMsg &&
                <li>
                  <Link className="navbar__item notification-anchor" id="messages" tabIndex="0" to="/messages" onClick={this.handleLinkClick} >
                    <icons.iconEnvelope />
                    {translation.navigation.messages}

                    {SessionStore.unreadCount > 0 &&
                      <span className="notification__count badge">{SessionStore.unreadCount}</span>
                    }
                  </Link>
                </li>
              }
              {!isIns &&
                <SessionStore.validater>
                  <li iamAction="sp:DescribePagesUi" iamResource={`ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:report`}>
                    <Dropdown ref="pagesDropdown" onShow={this.showDropdown} onHide={this.hideDropdown}>
                      <DropdownTrigger 
                        className="navbar__item" 
                        role="button" 
                        tabIndex="0" 
                        aria-controls="nav-pages" 
                        aria-haspopup="true" 
                        aria-expanded="false"
                      >
                        <icons.iconPage />
                        {!isAdd &&
                          translation.navigation.pages.anchor
                        }

                        {isAdd &&
                          translation.navigation.admin_pages
                        }
                      </DropdownTrigger>

                      <DropdownContent>
                        <ul id="nav-pages" className="dropdown__menu" aria-hidden="true">
                          <li>
                            <Link className="dropdown__item" to="/exam-approvals" onClick={this.handleLinkClick}>{translation.navigation.pages.exam_approvals}</Link>
                          </li>
                          <li>
                            <Link className="dropdown__item" to="/course-offerings" onClick={this.handleLinkClick}>{translation.navigation.pages.course_offerings}</Link>
                          </li>
                          <li iamAction="sp:DescribeVouchers" iamResource={`ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:voucher`}>
                            <Link className="dropdown__item" to="/vouchers" onClick={this.handleLinkClick}>{translation.navigation.pages.vouchers}</Link>
                          </li>
                          <li iamAction="sp:DescribeFundingRule" iamResource={`ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:funding`}>
                            <Link className="dropdown__item" to="/funding-rules" onClick={this.handleLinkClick}>{translation.navigation.pages.funding_rules}</Link>
                          </li>
                          <li iamAction="sp:CreateProctorAccount" iamResource={`ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:proctors`}>
                            <Link className="dropdown__item" to="/self-managed-proctors" onClick={this.handleLinkClick}>{translation.navigation.pages.self_managed_accounts}</Link>
                          </li>
                          {isAdd &&
                            <li>
                              <Link className="dropdown__item" to="/blackout-dates" onClick={this.handleLinkClick}>
                                {translation.navigation.pages.blackout_dates}
                              </Link>
                            </li>
                          }
                          {isAdd &&
                            <li>
                              <Link iamAction="sp:DescribeAdmins" iamResource={`ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:users`} className="dropdown__item" to="/admins" onClick={this.handleLinkClick}>
                                {translation.navigation.users.admins}
                              </Link>
                            </li>
                          }
                          {isAdd && SessionStore.userData.courseSid &&
                            <li>
                              <Link className="dropdown__item" to="/roster" onClick={this.handleLinkClick}>
                                {translation.navigation.users.roster}
                              </Link>
                            </li>
                          }
                          {isAdd &&
                            <li>
                              <Link className="dropdown__item" to="/users" onClick={this.handleLinkClick}>
                                {translation.navigation.users.anchor}
                              </Link>
                            </li>
                          }
                          {isAdd &&
                            <li>
                              <Link className="dropdown__item" to="/proctor-search" onClick={this.handleLinkClick}>
                                {translation.navigation.pages.proctor_search}
                              </Link>
                            </li>
                          }
                          {/* {isAdd &&
                            <li>
                              <a
                                className="dropdown__item" to="/proctor-search"
                                href={`https://smarterservices.typeform.com/to/iJvtxI?name=${profile.firstName} ${profile.lastName}&email=${profile.email}&institution=${userData.smarterProctoring.appInstallName}`}
                                target="_blank"
                                onClick={this.handleLinkClick}
                              >
                                {translation.navigation.pages.proctor_request}
                              </a>
                            </li>
                          } */}
                        </ul>
                      </DropdownContent>
                    </Dropdown>
                  </li>
                </SessionStore.validater>
              }
              {(!isAdd && !isIns) &&
                <SessionStore.validater>
                  <li iamAction="sp:DescribeUsersUi" iamResource={`ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:users`}  className="dropdown">

                    <Dropdown ref="usersDropdown" onShow={this.showDropdown} onHide={this.hideDropdown}>
                      <DropdownTrigger 
                        className="navbar__item" 
                        tabIndex="0" 
                        role="button" 
                        aria-controls="nav-users" 
                        aria-haspopup="true" 
                        aria-expanded="false"
                      >
                        <icons.iconList />
                        {translation.navigation.users.anchor}
                      </DropdownTrigger>

                      <DropdownContent>
                        <ul id="nav-users" className="dropdown__menu" aria-hidden="true">
                          <li>
                            <Link className="dropdown__item" to="/roster" onClick={this.handleLinkClick}>
                              {translation.navigation.users.roster}
                            </Link>
                          </li>
                          <li>
                            <Link iamAction="sp:DescribeAdmins" iamResource={`ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:users`} className="dropdown__item" to="/admins" onClick={this.handleLinkClick}>
                              {translation.navigation.users.admins}
                            </Link>
                          </li>
                        </ul>
                      </DropdownContent>
                    </Dropdown>
                  </li>
                </SessionStore.validater>
              }
              {isIns &&
                <li>
                  <Link className="navbar__item" to="/roster" onClick={this.handleLinkClick}>
                    <icons.iconList />
                    {translation.navigation.users.roster}
                  </Link>
                </li>
              }
              <li className="dropdown">
                <SmarterDropdown ref="accountDropdown" id="nav-account" tabIndex="0" onKeyDown={this.navbarKeydown} studentDropdownState={this.setStudentDropdown} triggerText={typeof profile.firstName !== 'undefined' &&
                      <span>
                        <abbr className={`avatar--initials ${profile.firstName.charAt(0).toLowerCase()}`} title={profile.firstName} aria-hidden="true">
                          {profile.firstName.charAt(0)}
                        </abbr>
                        <span className="capitalize">{profile.firstName}</span>
                      </span>
                    }>
                  <SessionStore.validater>
                    <li
                      iamAction="sp:DescribeUsers"
                      iamResource={`ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:user`}
                      role="menuitem"
                    >
                      <Link className="dropdown__item" id="student-dropdown" to="/settings" tabIndex="0" onClick={this.handleLinkClick}>{translation.navigation.account.settings}</Link>
                    </li>
                  </SessionStore.validater>
                  {(!isIns && !isStudent) &&
                    <SessionStore.validater>
                      <li
                        iamAction="sp:DescribeInstallSettings"
                        iamResource={`ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:install`}
                        role="menuitem"
                      >
                        <Link className="dropdown__item" to="/settings/institution/general" onClick={this.handleLinkClick}>{translation.navigation.account.institution_settings}</Link>
                      </li>
                    </SessionStore.validater>
                  }
                  {(!isIns && !isStudent) &&
                    <SessionStore.validater>
                      <li role="menuitem">
                        <Link className="dropdown__item" to="/integrations" onClick={this.handleLinkClick}>
                          {translation.navigation.account.integration_settings}
                        </Link>
                      </li>
                    </SessionStore.validater>
                  }
                  {(!isIns && !isStudent) &&
                    <SessionStore.validater>
                      <li
                        iamAction="sp:DescribeProctorGroups"
                        iamResource={`ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:proctorGroup`}
                        role="menuitem"
                      >
                        <Link className="dropdown__item" to="/settings/proctor-groups" onClick={this.handleLinkClick}>{translation.navigation.account.proctor_groups}</Link>
                      </li>
                    </SessionStore.validater>
                  }
                  {isStudent &&
                    <SessionStore.validater>
                      <li
                        iamAction="sp:DescribeUserLedger"
                        iamResource={`ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:user/${SessionStore.userData.userSid}`}
                        role="menuitem"
                      >
                        <Link className="dropdown__item" to="transactions" onClick={this.handleLinkClick}>{translation.navigation.account.transactions}</Link>
                      </li>
                    </SessionStore.validater>
                  }
                  {(!isIns && !isStudent) &&
                    <li role="menuitem">
                      <Link className="dropdown__item" to="ledger" onClick={this.handleLinkClick}>{translation.navigation.account.ledger}</Link>
                    </li>
                  }
                  {isAdd &&
                    <li className="dropdown__separated" role="menuitem">
                      <Link className="dropdown__item" to="/sign-out" onClick={this.handleLinkClick}>
                        {translation.navigation.account.sign_out}
                      </Link>
                    </li>
                  }
                  {isIns &&
                    <li role="menuitem">
                      <Link className="dropdown__item" to="/instructor-appointments" onClick={this.handleLinkClick}>
                        {translation.navigation.account.appointments}
                      </Link>
                    </li>
                  }
                  {isIns &&
                    <li role="menuitem">
                      <a
                        className="dropdown__item" to="/proctor-search"
                        href={`https://smarterservices.typeform.com/to/iJvtxI?name=${profile.firstName} ${profile.lastName}&email=${profile.email}&institution=${userData.smarterProctoring.appInstallName}&course=${courseData.code}`}
                        target="_blank"
                        onClick={this.handleLinkClick}
                      >
                        {translation.navigation.pages.proctor_request}
                      </a>
                    </li>
                  }
                </SmarterDropdown>
              </li>
              <li className="navbar__separator">
                <Help
                  btnClass="navbar__item"
                  setHelpDropdown={this.setHelpDropdown}
                  {...this.props}
                />
              </li>
              {/* {!isAdd &&
                <SessionStore.validater>
                  <li iamAction="sp:DescribeSupportTickets" iamResource={`ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:ticket`} className="navbar__separator">
                    <Link className="navbar__item" to="/support" onClick={this.handleLinkClick}>
                      <icons.iconQuestion />
                      {translation.navigation.account.support_tickets}
                    </Link>
                  </li>
                </SessionStore.validater>
              } */}
            </ul>
          </nav>
        }
      </header>
    );
  }
})

export default translate('Header')(Header);



// WEBPACK FOOTER //
// ./src/app/components/Common/Header.js